export default "__VITE_ASSET__DanfsEsJ__"